// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:768px){.inner[data-v-2dbd6408]{display:flex;flex-direction:row}}.inner>main[data-v-2dbd6408]{flex:1;min-width:0}@media only screen and (min-width:768px){.inner>main[data-v-2dbd6408] .container{padding-left:1.5em}}.inner>main .dashboard-content[data-v-2dbd6408]{min-height:calc(100vh - 406px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
